import type {
  ChainModifiers,
  Entry,
  EntryFieldTypes,
  EntrySkeletonType,
  LocaleCode,
} from 'contentful';
import type { TypeActionModalSkeleton } from './TypeActionModal';

export interface TypeExitIntentFields {
  contentTitleNotDisplayed?: EntryFieldTypes.Symbol;
  idleSeconds?: EntryFieldTypes.Integer;
  cookieLength: EntryFieldTypes.Integer;
  actionModal?: EntryFieldTypes.EntryLink<TypeActionModalSkeleton>;
}

export type TypeExitIntentSkeleton = EntrySkeletonType<
  TypeExitIntentFields,
  'exitIntent'
>;
export type TypeExitIntent<
  Modifiers extends ChainModifiers,
  Locales extends LocaleCode = LocaleCode,
> = Entry<TypeExitIntentSkeleton, Modifiers, Locales>;

export function isTypeExitIntent<
  Modifiers extends ChainModifiers,
  Locales extends LocaleCode,
>(
  entry: Entry<EntrySkeletonType, Modifiers, Locales>
): entry is TypeExitIntent<Modifiers, Locales> {
  return entry.sys.contentType.sys.id === 'exitIntent';
}

export type TypeExitIntentWithoutLinkResolutionResponse =
  TypeExitIntent<'WITHOUT_LINK_RESOLUTION'>;
export type TypeExitIntentWithoutUnresolvableLinksResponse =
  TypeExitIntent<'WITHOUT_UNRESOLVABLE_LINKS'>;
export type TypeExitIntentWithAllLocalesResponse<
  Locales extends LocaleCode = LocaleCode,
> = TypeExitIntent<'WITH_ALL_LOCALES', Locales>;
export type TypeExitIntentWithAllLocalesAndWithoutLinkResolutionResponse<
  Locales extends LocaleCode = LocaleCode,
> = TypeExitIntent<'WITHOUT_LINK_RESOLUTION' | 'WITH_ALL_LOCALES', Locales>;
export type TypeExitIntentWithAllLocalesAndWithoutUnresolvableLinksResponse<
  Locales extends LocaleCode = LocaleCode,
> = TypeExitIntent<'WITHOUT_UNRESOLVABLE_LINKS' | 'WITH_ALL_LOCALES', Locales>;
